<template>
<div :class="show_poster ? 'page page_yuekan page_shopdetail page_limit' :  'page page_yuekan page_shopdetail'">
    <!-- 头部信息 -->
    <div class="product top" v-if="data.info">
        <div class="pro_item clearfix">
            <div class="pro_item_l f-l">
                <img :src="imageUrl+data.info.thumb" alt="" class="tu">
            </div>
            <div class="pro_item_r f-l">
                <div class="pro_item_r_t clearfix">
                    <div class="title f-l slh_s">{{data.info.title}}</div>
                    <div class="price f-r"><span class="tag_cash">¥</span>{{data.info.price}}</div>
                </div>
                <div class="pro_item_r_b">
                    <div class="info clearfix">
                        <div class="info_l f-l">活动位置：</div>
                        <!-- <div class="info_r f-l">北京>张家口市>蔚县</div> -->
                        <div class="info_r f-l">
                            <span class="" v-if="data.info.provice">{{data.info.provice.areaname}}</span>
                            <span class="" v-if="data.info.city">{{'>'+ data.info.city.areaname}}</span>
                            <span class="" v-if="data.info.area">{{'>'+ data.info.area.areaname}}</span>
                        </div>
                    </div>
                    <div class="info dingwei clearfix">
                        <div class="info_l f-l">详细位置：</div>
                        <div class="info_r slh f-l">{{data.info.address}}</div>
                        <img :src="publicPath+'statics/images/yuekan/icon_dingwei.png'" alt="" class="icon_ding" @click="goAnywhere('河北省衡水市逸升佳苑')">
                    </div>
                    <div class="info clearfix">
                        <div class="info_l f-l">店铺类型：</div>
                        <div class="info_r f-l" v-if="data.info.type">{{data.info.type.title}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 内容区 -->
    <div class="content" ref="content"></div>
    <!-- 店信息 -->
    <div class="shop_info">
        <div class="info_t" v-if="data.info" @click="goShop(data.info.tradesman,'a')">
            <div class="info_t_l" v-if="data.info.tradesman">
                <img :src="data.info.tradesman.thumb ? ($publicData.withHttpStart(data.info.tradesman.thumb) ? data.info.tradesman.thumb : imageUrl+data.info.tradesman.thumb) : $publicData.defaultTouxiang" alt="" class="logo">
                <span class="name">{{data.info.tradesman.nickname}}</span>
            </div>
            <div class="info_t-r">进入店铺</div>
        </div>
        <div class="info_b" v-if="data.count">
            <div class="item" @click="goShop(data.info.tradesman,'a')">
                <div class="name">商品/作品</div>
                <div class="num">{{ data.count.mall }}</div>
            </div>
            <div class="item">
                <div class="line"></div>
            </div>
            <div class="item" @click="toFans(data.info.tradesman)">
                <div class="name">粉丝</div>
                <div class="num">{{data.count.attention}}</div>
            </div>
            <div class="item">
                <div class="line"></div>
            </div>
            <div class="item" @click="goShop(data.info.tradesman,'b')">
                <div class="name">约·看</div>
                <div class="num">{{data.count.live}}</div>
            </div>
        </div>
    </div>
    <!-- 咨询购买 -->
    <div class="bottom">
        <div class="bottom_tab home" @click="goPage('/')">首页</div>
        <div class="bottom_tab zixun" @click="serveClick">咨询</div>
		<div class="bottom_tab share" @click="show_poster = true">分享</div>
        <div class="buy" @click="buyFun">立即购买</div>
    </div>
	<!-- 分享的图片,类似海报 -->
	<van-overlay :show="show_poster" @click="show_poster = false" class="" />
	<div class="poster" v-if="show_poster">
		<img :src="$publicData.imgPath + posterUrl" alt="" class="posterTu">
	</div>
	<div class="share_tips" v-if="show_poster">长按保存图片</div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "home-index",
    data() {
        return {
			richImageUrl: this.$publicData.richTextImage,
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            id: this.$route.query.id, // 约看id
            data: {}, // 数据
            shareConfig: null, // 分享的相关配置
			token: null,
			show_poster: false, // 海报弹层
			posterUrl: null // 分享图链接
        };
    },
    created: function () {
        //测试token
        // this.$store.commit(LOGIN, {
        //     token: 'JdkjGWTfej6fLzhzukVfrw==',
        // });
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    naviTitle: '约看详情',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            //  title: that.data.info.title ? that.data.info.title : that.$publicData.shareDefaultTitleA, // 分享标题
            //         desc: that.data.info.describe ? that.data.info.describe : '', // 分享描述
            //         link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            //         imgUrl: that.data.info.thumb ? that.$publicData.domain + that.data.info.thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.data.info.title ? that.data.info.title : that.$publicData.shareDefaultTitleA,
                        detail: that.data.info.describe ? that.data.info.describe : '',
                        url: url,
                        platFormType:'',
                        image: that.data.info.thumb ? that.$publicData.domain + that.data.info.thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token
        }
		this.getData()
		// 获取分享图片
		this.getSharePoster()
    },
    methods: {
        // 获取数据
        getData() {
			let that = this;
            console.log('id', this.id)
            var params = {
                id: this.id
            }
            this.$api.live.detail(params).then(res => {
                if (res.code == 200) {
                    console.log('res')
                    this.data = res.result
                    // 内容区
					console.log($(this.$refs.content))
					var content = res.result.info.content;
					content = content.replace(/\<iframe/g, '<iframe width="100%"')
					// 处理富文本
					content = content.replace(/(<img [^>]*src=['"])([^'"]+)([^>]*)/g,function(match,$1,$2,$3){
						if(/^http/.test($2)){
							return $1 + $2 + $3;
						}else{
							return $1 + that.richImageUrl +$2 + $3;
						}
					});
					$(this.$refs.content).html(content);
					// 调起 微信分享获取参数
                    this.getShareData();
                }
            })
        },
        // 页面跳转
        goPage(path) {
            this.$router.push({
                path: path
            })
        },
        // 去哪个地方 具体地址
        goAnywhere(address) {
            this.$router.push({
                path: '/map/anywhere',
                query: {
                    address: address
                }
            })
        },
        // 购买 
        buyFun() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
                                'data': {
                                    'url': this.$publicData.clientUrl + '/yuekan/book?id=' + this.id
                                }
                            }
                            this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        }
                    }
                );

            } else {
                // 验证是否登录
                if (!this.$store.getters.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
                }
                this.$router.push({
                    path: '/yuekan/book',
                    query: {
                        id: this.id
                    }
                })
            }

        },
        // 进入店铺  type == 'a'是商品 'b'是约看
        goShop(tradesman, type) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + tradesman.id + '&type=' + type
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: tradesman.id,
                        type: type
                    }
                })
            }
        },
        // 查看粉丝
        toFans(tradesman) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/fans/index?tradesmanId=' + tradesman.id + '&tradesman_uuid=' +　tradesman.uuid
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/fans/index',
                    query: {
						tradesmanId: tradesman.id,
						tradesman_uuid: tradesman.uuid
                    }
                })
            }
        },
        goDevelop() {
            this.$router.push({
                path: '/system/develop'
            })
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.data.info.title ? that.data.info.title : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.data.info.describe ? that.data.info.describe : '', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.data.info.thumb ? that.imageUrl+ that.data.info.thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
        serveClick() {
            var that = this;
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var memberParams = {
                        data: {},
                    };
                    this.$bridge.callhandler("sdjy://member/memberInfo", memberParams, (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            var params = {
                                token: this.token,
                                uuid: that.data.info.tradesman.uuid
                            };
                            that.$api.xiaoxi.userInfo(params).then(res => {
                                if (res.code == 200) {
                                    var tradesmanInfo = res.result;
                                    // console.log('创建了与匠人的通信')
                                    // that.$parent.sendMsgToTradesman('与' + that.tradesmanInfo.username + '建立了通信', that.mine.userId, that.tradesmanInfo.im_username);

                                    that.toAppServe(tradesmanInfo);
                                }
                            })
                            
                        }
                    });
            } else {
                if (!that.$store.getters.token) {
                    localStorage.setItem('redirect', that.$router.currentRoute.fullPath)
                    that.$router.push({
                        path: '/login',
                    })
                    return
                }
                console.log(that.data)
                that.$router.push({
                    path: '/tradesman/chat',
                    query:{
                        uuid: that.data.info.tradesman.uuid 
                    }
                })
            }
        },
        toAppServe(tradesmanInfo) {
            var that = this
            var params = {
                data: {
                    toId: tradesmanInfo.im_username,
                    conversationId: tradesmanInfo.im_username,
                    toAvator: tradesmanInfo.tradesmans.thumb,
                    toName: tradesmanInfo.tradesmans.nickname,
                    toUUID: tradesmanInfo.uuid,
                    toPhone: tradesmanInfo.tradesmans.data.phone,
                    trandsmanId: tradesmanInfo.tradesmans.id
                },
            }
            this.$bridge.callhandler("sdjy://public/chat",params,(data) => {

            });
        },
		// 获取分享图片 ** 后台返回的
		getSharePoster(){
			var that = this
			var params = {
				id: that.id,
				type: 4 // 1商品 2匠人 3直播 4约看
			}
			that.$api.common.shareImg(params).then(res=>{
				if(res.code == 200){
					that.posterUrl = res.result
				}else{
					that.$toast(res.message)
				}
			})
		}
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	
</style>
